import { createFileRoute } from "@tanstack/react-router";

import { CatalogSetupPage } from "../../../features/catalog/catalog-setup-page";

export const Route = createFileRoute("/_app/catalog/setup")({ component: CatalogSetupPage });
